import React, { useEffect, useState } from 'react';
import PageHeaderText from 'components/base/page-header-text';
import useDashboardContext from 'contexts/dashboard.context';
import { MAIN_STORE_ROUTE_KEYS } from 'utils/constants';
import FormStepper from 'components/base/form-stepper';
import usePricingContext from 'contexts/pricing.context';
import { apiService } from 'services/base.service';
import { ToastMessage } from '@cokitchen/cokitchen-components';
import { toast } from 'react-toastify';
import { useLocation, useNavigate } from 'react-router-dom';

import { BaseMealFormType } from 'models/pricing.model';
import LinkBaseMeal from 'components/link-base-meal';

export const DefaultBaseMealFormData: BaseMealFormType = {
  base_meal_id: '',
  name: '',
  items: [
    {
      mix_id: '',
      quantity: ''
    }
  ],
  itemIndex: 0
};

const EditBaseMeals = () => {
  const location = useLocation();
  const { state } = location;
  const { setIsBackLink, setBackLinkTitle, setBackLink } = useDashboardContext();
  const [isCreatingVendors, setIsCreatingVendors] = useState(false);
  const {
    baseMealsFormData,
    step,
    setStep,
    setBaseMealFormData,
    selectedBaseMeal,
    setSelectedBaseMeal
  } = usePricingContext();
  const router = useNavigate();

  useEffect(() => {
    setIsBackLink(true);
    setBackLinkTitle('Return to vendors');
    setBackLink(MAIN_STORE_ROUTE_KEYS.VENDORS);
    return () => {
      setIsBackLink(false);
    };
  }, []);

  const editConversionItem = async () => {
    const payload =
      baseMealsFormData?.map((meal) => {
        return {
          base_meal_id: meal?.base_meal_id ?? '',
          items: [
            ...(meal?.items?.map((_) => {
              return {
                quantity: Number(_.quantity ?? 0),
                mix_id: _.mix_id
              };
            }) ?? [])
          ]
        };
      }) ?? [];
    const data = payload?.[0];

    try {
      setIsCreatingVendors(true);
      const res = await apiService.post('meal_link', { data, version: 'v2' });
      if (res) {
        router(MAIN_STORE_ROUTE_KEYS.BASE_MEALS);
        setBaseMealFormData([DefaultBaseMealFormData]);
        toast(<ToastMessage message='Excel meal linked successfully' type='success' />);
      }
    } catch (err: any) {
      toast(
        <ToastMessage
          message={err.response?.data?.message || 'Error linking excel meal'}
          type='error'
        />
      );
    } finally {
      setIsCreatingVendors(false);
    }
  };

  return (
    <div>
      <PageHeaderText
        title={state?.[0]?.name}
        description='Accurately map excel meals that make up this offer'
      />
      <div className='max-w-[878px]'>
        <FormStepper
          disabled={false}
          title=''
          step={step}
          handleConfirmClick={editConversionItem}
          setStep={setStep}
          onNextClick={() => {
            if (selectedBaseMeal) return;
            setSelectedBaseMeal({
              ...baseMealsFormData[0],
              itemIndex: 0
            });
          }}
          noOfSteps={1}
          hideSteps
          loading={isCreatingVendors}>
          <LinkBaseMeal />
        </FormStepper>
      </div>
    </div>
  );
};

export default EditBaseMeals;
